<template>
    <main>
        <Hero title="Blog" colour-index="0" sidebar
            subtitle="Search through our list of FAQs and Articles to help you integrate our APIs" left>
            <template #sidebar>
                <a class="float-right btn btn-sm btn-primary mb-8 flex flex-nowrap gap-2 items-center" href="/rss.xml"
                    target="_blank">
                    <span>RSS Feed</span>
                    <Icon name="ic:baseline-rss-feed" class="text-lg ml-1" />
                </a>
            </template>
        </Hero>


        <div class="page-heading sm:mt-6 sm:mb-6 sm:px-28 ">
            <small class="text-medium-gray font-semibold uppercase">Recent Articles</small>
            <div class="gap-y-3 flex flex-wrap" :class="{ 'max-h-0 opacity-0': !isReady }">

                <Article v-if="guidesArticle" :article="guidesArticle as any" class="w-full lg:w-1/3 article-fade"
                    include_html />
                <Article v-if="productArticle" :article="productArticle as any" class="w-full lg:w-1/3" include_html />
                <Article v-if="caseStudiesArticle" :article="caseStudiesArticle as any" class="w-full lg:w-1/3"
                    include_html />
                <!-- <Article :article="(data?.find((a) => a.tag.includes('Case Studies')) as any)" class="w-full lg:w-1/3"
                include_html /> -->
            </div>
        </div>

        <div v-if="!isReady" class="loading p-20">
            <div role="status">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
            </div>
        </div>

        <header class="page-heading mx-3 sm:mx-28 mt-12">
            <!-- <SubTitle title="Blog" /> -->

            <!-- <a class="btn btn-sm btn-primary mb-8 flex flex-nowrap gap-2 items-center" href="/rss.xml" target="_blank">
                <span>RSS Feed</span>
                <Icon name="ic:baseline-rss-feed" class="text-lg ml-1" />
            </a> -->

            <!-- <input type="search" v-model="search" placeholder="Search..."
                class="search-bar w-full rounded-lg py-2 px-4 text-lg mb-8" /> -->

            <small class="text-medium-gray font-semibold uppercase">Categories</small>
            <!-- <a class="btn btn-sm text-xs btn-primary py-1 px-2 float-right flex flex-nowrap gap-2 items-center"
                href="/rss.xml" target="_blank">
                <span>RSS Feed</span>
                <Icon name="ic:baseline-rss-feed" class="text-lg" />
            </a> -->
            <Tabs :options="['All', 'Guides', 'Product', /*'Engineering',*/ 'Insights', 'Case Studies']"
                v-model="section" />

            <input type="search" v-model="search" placeholder="Search..."
                class="search-bar w-full rounded-lg py-2 px-4 text-lg mb-8 mt-4" />

        </header>

        <div class="page-heading sm:mt-6 sm:pb-6 sm:px-28 gap-y-3 flex flex-wrap"
            :class="{ 'max-h-0 opacity-0': !isReady }">
            <Article class="w-full lg:w-1/3" v-for="article in data" :key="article.path"
                v-show="article.title?.toLowerCase().includes(search.toLowerCase()) && (section === 'All' || section === article.tag)"
                :article="(article as any)" />
        </div>
        <div v-if="!isReady" class="loading p-20">
            <div role="status">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
useSEO({
    title: 'Blog',
    description:
        'Guides, product updates, insights, and case studies from Unified.to — learn how to integrate APIs faster with a real-time unified API and MCP platform.',
});

definePageMeta({
    alias: ['/help'],
});

import { BLOG_CARD_FIELDS } from '~/services/blog';

// Card fields only: the result is inlined into the page payload.
const { data } = await useAsyncData('blog-cards', () =>
    queryCollection('content')
        .where('path', 'LIKE', '/blog/%')
        .select(...BLOG_CARD_FIELDS)
        .order('date', 'DESC')
        .all()
);

const guidesArticle = data.value?.find(article => article.tag?.includes('Guides'));
const productArticle = data.value?.find(article => article.tag?.includes('Product'));
const caseStudiesArticle = data.value?.find(article => article.tag?.includes('Case Studies'));

</script>


<script lang="ts">

export default {
    // async setup() {
    //     useHead({
    //         title: 'Blog | Unified.to',
    //         meta: [{ name: 'description', content: 'Blog | Unified.to' }],
    //     });

    //     definePageMeta({
    //         alias: ['/help'],
    //     });
    //     // const { data } = await useAsyncData('blog', () => queryContent('/blog').find());

    //     const { data } = await useAsyncData('blog', () => queryContent('/blog').sort({ date: -1 }).find());

    //     const guidesArticle = computed(() => data.value?.find(article => article.tag?.includes('Guides')));
    //     const productArticle = computed(() => data.value?.find(article => article.tag?.includes('Product')));
    //     const insightsArticle = computed(() => data.value?.find(article => article.tag?.includes('Insights')));

    //     return {
    //         data,
    //         guidesArticle,
    //         productArticle,
    //         insightsArticle,
    //     };
    // },
    data() {
        return {
            isReady: false,
            section: 'All',
            // query: { path: '/articles', limit: 10, sort: { date: -1 } as any, where: { title: this.search } } as QueryBuilderParams,
            search: '',
            // articles: data?.value as unknown as IArticle[],
        };
    },

    mounted() {
        // Handle initial hash in URL
        const hash = window.location.hash.slice(1); // Remove the # symbol
        if (hash) {
            // Convert hash to proper tab name format (e.g. case-studies -> Case Studies)
            const tabName = hash.split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');

            if (['All', 'Guides', 'Product', 'Insights', 'Case Studies'].includes(tabName)) {
                this.section = tabName;
            }
        }

        setInterval(() => {
            this.isReady = true;
        }, 1000);
    },

    watch: {
        section(newSection) {
            // Convert section name to URL-friendly format (e.g. Case Studies -> case-studies)
            const hash = newSection === 'All' ? '' : newSection.toLowerCase().replace(' ', '-');
            // Get pathname without trailing slash
            const pathname = window.location.pathname.replace(/\/$/, '');
            // Update URL without triggering a page reload
            if (hash) {
                window.history.replaceState(null, '', `${pathname}#${hash}`);
            } else {
                window.history.replaceState(null, '', pathname);
            }
        }
    }
};
</script>
<style></style>